import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import IconButton from '@mui/material/IconButton';
import signo from '../assets/ImgMasInfo.svg'
import IntentionNum from '../components/IntentionNum';
import { Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentTab, setGlobalTab } from '../redux/reducer/stepReducer/stepReducer';

export default function ButtonDrawer({ codpmpol }) {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { codemp } = useSelector(state => state.adminReducer.login);

  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <>
          <IconButton variant="contained" {...bindTrigger(popupState)}>
            <img style={{ width: '100%' }} src={signo} alt="" />
          </IconButton>

          <Menu {...bindMenu(popupState)}>
            <MenuItem><IntentionNum codpmpol={codpmpol} /></MenuItem>
            <MenuItem>
              <Typography variant="body2" color="text.secondary" style={{ fontFamily: 'Roboto', fontSize: '0.9 rem', marginTop: '15px' }}>
                Platform {codemp > 50 && 'UAT'} v2.5.0
              </Typography>
            </MenuItem>
            <MenuItem onClick={() => {
              dispatch(setCurrentTab(2));
              dispatch(setGlobalTab(2.0));
              navigate('/questions')
            }}>
              <Typography variant="body2" color="text.secondary" style={{ fontFamily: 'Roboto', fontSize: '0.9 rem', marginTop: '15px' }}>
                Preguntas frecuentes
              </Typography>
            </MenuItem>
            <MenuItem onClick={popupState.close}>
              <Typography variant="body2" color="text.secondary" style={{ fontFamily: 'Roboto', fontSize: '0.9 rem', marginTop: '15px' }}>
                Cerrar
              </Typography>
            </MenuItem>
          </Menu>
        </>
      )}
    </PopupState>
  );
}